'use strict';
(function(angular) {
  var CONTROLLER_NAME = "WelcomeCtrl";
  angular
    .module('activationApp.controllers')
    .controller(CONTROLLER_NAME, [
      '$scope',
      '$location',
      'dataService',
      '$rootScope',
      function(
        $scope,
        $location,
        dataService,
        $rootScope,
      ) {
        $scope.$emit('Progress.Hide');

        $scope.activate = function() {
          if($scope.blockNext) return;

          $rootScope.user = {};
          dataService.resetData();
          if (dataService.showPartners()) {
            $location.path('/options');
          } else {
            $location.path('/activate/step1');
          }
        };
      }
    ]);
})(angular);

